const fs = require("fs");
const nconf = require("nconf");
const globalStylingHooksSets = require('./preval/styling-hooks.preval');
const componentStylingHooksSets = require('./preval/component-hooks.preval');
const Immutable = require("immutable");

nconf.argv();
const generateToFile = nconf.get("to-file");
const concatHooksArray = [
  ...globalStylingHooksSets,
  ...componentStylingHooksSets,
];
const hooksData = JSON.stringify(concatHooksArray);

const writeFile = (data) => {
  fs.writeFile("styling-hooks.json", hooksData, "utf8", (err) => {
    if (err) {
      console.error("Error writing JSON file:", err);
    } else {
      console.log("JSON file has been saved successfully.");
    }
  });
};

const generate = (data, toFile) => {
  if (!toFile) {
    console.log(data);
  }
  return toFile ? writeFile(data) : data;
};

// Export the function writeFile as default
module.exports = generate(hooksData, generateToFile);